module.exports = __webpack_public_path__ + "static/media/DG8960G0.b141b017.png";